import { useContext } from 'react';
import { store } from '../store';
import usePlayerSelector from './usePlayerSelector';

const DEFAULT_PLAYER_SETTINGS = {
    ShowGameScore: true,
};
const usePlayerSettings = () => {
    const { state: { playerSettings } } = useContext(store);

    const { IsMlb, IsPitcher } = usePlayerSelector();
    if (!!playerSettings && IsMlb && IsPitcher) return { ...playerSettings, ShowGameScore: true };

    return playerSettings ?? DEFAULT_PLAYER_SETTINGS;
};

export default usePlayerSettings;
